import { render, staticRenderFns } from "./TabCallback.vue?vue&type=template&id=3561d88d"
import script from "./TabCallback.vue?vue&type=script&lang=js"
export * from "./TabCallback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports